import React, { ReactNode } from 'react';
import cls from '@utils/css-select';

import styles from './styles.scss';
import Section from 'components/section';
import CountrySelector from 'components/country-selector';
import { Link } from 'react-router-dom';
import { sendEvent } from '@utils/core/track';

const cx = cls(styles);

export type IHeaderProps = {
  children?: ReactNode;
  showRight?: boolean;
  title?: ReactNode;
  isShowJoin?: boolean;
};

/**
 * 全局容器
 * @param props
 * @returns
 */
export default function Header(props: IHeaderProps) {
  const { showRight = true, title = '', isShowJoin = false } = props;
  return (
    <header className={ cx('header') }>
      <Section className={ cx('inner') }>
        {/* <div className={cx('brand')} onClick={() => history.push('/en')}> */ }
        <div className={ cx('brand') }>
          <img
            loading='lazy'
            className={ cx('logo') }
            src='https://web-data.zmlearn.com/image/8UhXesmBNq64iYXEsKpb1N/logo_nav%402x.png'
            alt='air-class'
          />
          {/*<span className={ cx('split-h') }/>*/ }
          {/*<span className={ cx('tip') }>{ title }</span>*/ }
        </div>
        <div className={ cx('right-tools') }>
          { isShowJoin && (
            <Link to='/en/recruit' className={ cx('join') } onClick={ () => sendEvent({ eventId: 'shouye_joinus' }) }>
              Join Us
            </Link>
          ) }
          { showRight && <CountrySelector /> }
        </div>
      </Section>
    </header>
  );
}
